export const dataKeyUser = {
  access_user: 'Access user',
  control_access_ip: 'Control access ip',
  send_email: 'Send email',
  title: 'Title',
  first_name: 'First name',
  last_name: 'Last name',
  social_security_number: 'Social security number',
  date_of_birth: 'Date of birth',
  birth_country: 'Birth_country',
  birth_city: 'Birth city',
  birth_department: 'Birth department',
  birth_name: 'Birth name',
  nationality: 'Nationality',
  public_holiday_calendar_id: 'Public holiday calendar',
  department_id: 'Department',
  department__name: 'Department name',
  service__name: 'Service name',
  absence_policy__name: 'Absence policy name',
  personal_email: 'Personal Email',
  public_holiday_calendar__name: 'Public holiday calendar name',
  contract_start_date: 'Contract start date',
  contract_start_reason: 'Contract start reason',
  company_start_date: 'Company start date',
  seniority_date: 'Seniority date',
  working_time_unit: 'Working time unit',
  employment_contract: 'Employment contract',
  professional_status: 'Professional status',
  contract_end_date: 'Contract end date',
  contract_end_reason: 'Contract end reason',
  job_title: 'Job title',
  job_number: 'Job number',
  theme_config: 'Theme config',
  introductory_phrase: 'Introductory phrase',
  cover_photo: 'Cover photo',
  default_calendar: 'Default calendar',
};

export const mockKeyStaffLeave = {
  name: 'Name',
  description: 'Description',
  long_description: 'Long description',
  comment: 'Comment',
  french_description: 'French description',
  french_long_description: 'French long description',
  french_comment: 'French comment',
  is_active: 'Is active',
  calendar_color: 'Calendar color',
  font_color: 'Font color',
  calendar_code: 'Calendar code',
  accruing_type: 'Accruing Type',
  balance: 'Balance',
  reset_counter_day: 'Reset counter day',
  reset_counter_month: 'Reset counter month',
  accruing_conditions: 'Accruing conditions',
};
